import {configureStore} from "@reduxjs/toolkit";
import skipassSlice from "./skipassSlice";
import cartSlice from "./cartSlice";

export default configureStore({
    reducer: {
        skipassesList: skipassSlice,
        cartList: cartSlice,
    },
});
